import { Component, ViewEncapsulation, ChangeDetectorRef, ViewContainerRef } from "@angular/core";
import { SharedService } from '../shared';
import {
    IQuestionnaireSection, IQuestionnaireSubSection, IQuestionnaireQuestion, freeTextInputs,
    EnumSectionStatus, EnumInputSize, EnumFreeTextType, EnumQuestionType, EmptyAnswer,
    EnumSectionType, GenereateSymptome, ISymptomeObj, IExtraOptionAnswer, EnumMedikamentName, IMedikamentResObj, INichtMedikamentResObj,
    EnumCAMTherapieName, ICAMTherapieResObj, ICAMTherapieEndResObj,
    IQuestionnaireResponse, IMedikamentObj, ICAMTherapieObj, getCategoryLabel, RecordStatusEnum, LANGUAGE_ENUM
} from './questionnaire.model';

import {
    QuestionnaireJSON, CamTherapieSecondSubSection, CamTherapieFourthSubSection,
    NebenwirkungenSecondSubSection, KeineNebenwirkungen
} from './questionnaire.data';

import {
    QuestionnaireJSON_EN, CamTherapieSecondSubSection_EN, CamTherapieFourthSubSection_EN,
    NebenwirkungenSecondSubSection_EN, KeineNebenwirkungen_EN
} from './questionnaire-en.data';

import { ICDCodePopupComponent } from './icd-code-popup';
import { PEPInfoComponent } from './pep-info';
import * as moment from 'moment';
import { cloneDeep } from "lodash";

declare var jsPanel: any;

@Component({
    selector: 'app-dateneingabe-frageboge-common',
    template: '',
    encapsulation: ViewEncapsulation.None
})
export class DateneingabeFragebogeCommonComponent {
    LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;
    LANGUAGE_ENUM = LANGUAGE_ENUM;

    showLoader: boolean = false;

    InEditRecordPopup: boolean = false;

    QuestJSON: IQuestionnaireSection[] = [];
    EnumSectionStatus = EnumSectionStatus;
    EnumInputSize = EnumInputSize;
    EnumFreeTextType = EnumFreeTextType;
    EnumQuestionType = EnumQuestionType;
    EnumSectionType = EnumSectionType;

    minMonth: Date = null;
    maxMonth: Date = null;

    jsPanelPopup: any;

    get panelWidth() {
        return Math.min(1400, window.innerWidth * 0.9);
    }

    get panelHeight() {
        return Math.min(1100, window.innerHeight * 0.9);
    }

    constructor(protected cd: ChangeDetectorRef,
        protected vcr: ViewContainerRef,
        protected sharedService: SharedService) {
    }


    logout() {
        window.open("/pep/dateneingabe/frageboge", "_self");
    }

    refresh() {
        window.location.reload();
    }

    fnLoadQuestionnaire() {
        this.minMonth = new Date(moment().year(1980).month(0).startOf("month").toString());
        this.maxMonth = new Date(moment().startOf('month').add(1, 'months').endOf("month").toString());

        this.QuestJSON = cloneDeep(this.LANGUAGE == LANGUAGE_ENUM.EN ? QuestionnaireJSON_EN : QuestionnaireJSON);
        if (!this.InEditRecordPopup) {
            this.QuestJSON[0].status = EnumSectionStatus.ACTIVE;
            this.QuestJSON[0].subSections[0].status = EnumSectionStatus.ACTIVE;
        }
    }

    isFreeTextShow(question: IQuestionnaireQuestion) {
        if (question.inputType == EnumQuestionType.DROPDOWN) {
            let value = question.answer.value;
            if (value) {
                if (question.multiple) {
                    var matched = freeTextInputs.filter(e => value.indexOf(e) !== -1);
                    return matched.length > 0;
                } else {
                    return freeTextInputs.indexOf(value) > -1;
                }
            }
        }
        return false;
    }

    setConditonalOptions(JSONData: IQuestionnaireSection[], question: IQuestionnaireQuestion, onChagne: boolean) {
        if (question.conditionalOptions) {
            let dependedKey = question.conditionalOptions.dependedKey;
            if (!question.conditionalOptions.options) {
                let value = question.answer.value;
                JSONData.forEach(_section => {
                    _section.subSections.forEach(_subSection => {
                        _subSection.questions.forEach(_question => {
                            if (_question.conditionalOptions) {
                                let _dependedKey = _question.conditionalOptions.dependedKey;
                                let _options = _question.conditionalOptions.options;
                                if (_options && dependedKey === _dependedKey) {
                                    let _option = _options.find(a => a.label == value);
                                    let data = _option ? _option.options || [] : [];
                                    if (onChagne) {
                                        _question.answer = EmptyAnswer();
                                    }
                                    _question.data = data;
                                }
                            }
                        })
                    })
                })
            }
        }
    }

    fnShowHideQuestions(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion) {
        if (section.number == 2 && subSection.number == 1) {
            let answer = question.inputType == EnumQuestionType.OPTION ? (question.answer.value ? question.answer.value[0] : "") : question.answer.value;
            if (question.number == 1) {
                let question2 = subSection.questions.find(a => a.number == 2);
                if (answer == question.data[1]) {
                    question2.hidden = false;
                    question2.required = true;
                } else {
                    question2.hidden = true;
                    question2.required = false;
                    question2.answer = EmptyAnswer();

                }
            }
            if (question.number == 7) {
                let question8 = subSection.questions.find(a => a.number == 8);
                let question9 = subSection.questions.find(a => a.number == 9);
                if (answer === question.data[0]) {
                    question8.hidden = false;

                    question9.hidden = true;
                    question9.answer = EmptyAnswer();
                } else if (answer === question.data[1]) {
                    question9.hidden = false;

                    question8.hidden = true;
                    question8.answer = EmptyAnswer();
                } else {
                    question8.hidden = true;
                    question8.answer = EmptyAnswer();

                    question9.hidden = true;
                    question9.answer = EmptyAnswer();
                }
            }
            if (question.number == 11) {
                let question12 = subSection.questions.find(a => a.number == 12);
                if (answer === question.data[1]) {
                    question.divider = false;
                    question12.hidden = false;
                } else {
                    question.divider = true;
                    question12.hidden = true;
                    question12.answer = EmptyAnswer();
                }
            }
        }
    }

    changeFunction(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion) {
        if (subSection.status == EnumSectionStatus.COMPLETED) {
            return;
        }
        question.hasError = false;
        this.setConditonalOptions(this.QuestJSON, question, true);
        if (!this.isFreeTextShow(question)) {
            question.answer.freeText = null;
        }
        this.fnShowHideQuestions(section, subSection, question);

    }

    quillChangeFunction(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion) {
        this.changeFunction(section, subSection, question);
    }

    freeTextChangeFunction(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion) {
        question.hasError = false;
    }

    onPosNegSliderChange(event: any, section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion) {
        question.answer.value = event.value;
        if (event.value != 0) {
            question.hasError = false;
        }
    }

    isOptionSelected(question: IQuestionnaireQuestion, option: string) {
        let value = question.answer.value || [];
        return value.indexOf(option) > -1;
    }

    fnSelectOption(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion, option: string) {
        if (subSection.status == EnumSectionStatus.COMPLETED) {
            return;
        }
        let value = question.answer.value || [];
        if (question.multiple) {
            let index = value.indexOf(option);
            if (index == -1) {
                value.push(option);
            } else {
                value.splice(index, 1);
            }
        } else {
            value = [option];
        }

        if (subSection.required) {
            subSection.questions.forEach(quest => {
                quest.hasError = false;
            })
        }

        question.hasError = false;
        question.answer.value = value;
        this.fnShowHideQuestions(section, subSection, question);
        this.fnSetCamSection(section, subSection);
        this.fnSetNebSection(section, subSection);
        this.fnUpdateSymptomes(section, subSection);
        this.cd.detectChanges();
    }

    fnAddExtraOption(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion) {
        if (subSection.status == EnumSectionStatus.COMPLETED) {
            return;
        }
        let extraOptions = question.answer.extraOptions || [];
        if (question.extraOption.multiple) {
            extraOptions.push({ value: '' });
        }
        else {
            if (extraOptions.length == 0) {
                extraOptions = [{ value: '' }];
            }
        }
        if (subSection.required) {
            subSection.questions.forEach(quest => {
                quest.hasError = false;
            })
        }
        question.hasError = false;
        question.answer.extraOptions = extraOptions;
        this.fnSetCamSection(section, subSection);
        this.fnSetNebSection(section, subSection);
        this.fnUpdateSymptomes(section, subSection);
        this.cd.detectChanges();
    }

    fnRemoveExtraOption(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion, index: number) {
        if (subSection.status == EnumSectionStatus.COMPLETED) {
            return;
        }
        let extraOptions = question.answer.extraOptions || [];
        extraOptions.splice(index, 1);
        question.answer.extraOptions = extraOptions;
        this.fnSetCamSection(section, subSection);
        this.fnSetNebSection(section, subSection);
        this.fnUpdateSymptomes(section, subSection);
        this.cd.detectChanges();
    }

    extraOptionChangeFunction(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion, extraOption: IExtraOptionAnswer) {
        if (subSection.status == EnumSectionStatus.COMPLETED) {
            return;
        }
        extraOption.hasError = false;
        this.fnSetCamSection(section, subSection);
        this.fnSetNebSection(section, subSection);
        this.fnUpdateSymptomes(section, subSection);
        this.cd.detectChanges();
    }


    openICDCodePopup(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, question: IQuestionnaireQuestion) {
        if (subSection.status == EnumSectionStatus.COMPLETED) {
            return;
        }

        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            if (!this.InEditRecordPopup) {
                panel.close();
            }
        })

        let component = this;
        // Code for get html element from component
        const componentRef = this.vcr.createComponent(ICDCodePopupComponent);
        componentRef.instance.LANGUAGE = this.LANGUAGE;
        componentRef.instance.selectedOptions = question.answer.extraOptions || [];

        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            id: "jsPanelICDPopup",
            theme: 'dark',
            footerToolbar: [
                `<button type="button" class="btn btn-sm btn-danger me-2" data-type="close">${this.LANGUAGE == LANGUAGE_ENUM.EN ? 'Cancel' : 'Abbrechen'}</button>`,
                `<button type="button" class="btn btn-sm btn-success" data-type="ok">${this.LANGUAGE == LANGUAGE_ENUM.EN ? 'Apply' : 'Übernehmen'}</button>`
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            css: {
                panel: this.InEditRecordPopup ? 'jsPanelFixed' : ''
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: question.icdCode.popupTitle,
            onwindowresize: true,
            onstatuschange: (panel, status) => {
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                if (componentRef.instance.selectedOptions.length) {
                                    const options = componentRef.instance.selectedOptions;
                                    question.answer.extraOptions = options;
                                }
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup);
    }

    fnUpdateSymptomes(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        if (subSection.symptomeObj) {
            let dependedByThis = subSection.symptomeObj.dependedByThis;
            if (dependedByThis) {
                section.subSections.forEach(_subSection => {
                    if (_subSection.symptomeObj) {
                        let dependedToThis = _subSection.symptomeObj.dependedToThis;
                        if (dependedByThis === dependedToThis) {
                            let answers = [];
                            subSection.questions.forEach(question => {
                                if (question.answer.value) {
                                    answers = [...answers, ...question.answer.value];
                                }
                                question.answer.extraOptions.forEach(option => {
                                    if (option.value) {
                                        answers.push(option.value);
                                    }
                                })
                            })
                            let symptomes: ISymptomeObj[] = [];
                            answers.forEach(answer => {
                                let _KeineNebenwirkungen = this.LANGUAGE == LANGUAGE_ENUM.EN ? KeineNebenwirkungen_EN : KeineNebenwirkungen;
                                if (_KeineNebenwirkungen !== answer) {
                                    symptomes.push(GenereateSymptome(dependedToThis, answer, this.LANGUAGE));
                                }
                            })
                            _subSection.symptomeObj.symptomes = symptomes;
                            this.cd.detectChanges();
                        }
                    }
                })
            }
        }
    }

    fnSetCamSection(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        if (section.number == 7) {
            if (subSection.number == 1) {
                let _question = subSection.questions.find(a => a.number == 1);
                let value = _question.answer.value;
                let index = section.subSections.findIndex(a => a.number == 2 && a.therapieObj != null);

                if (value && _question.data[0] === value[0]) {
                    if (index < 0) {
                        let camSection = cloneDeep(this.LANGUAGE == LANGUAGE_ENUM.EN ? CamTherapieSecondSubSection_EN : CamTherapieSecondSubSection);
                        if (this.InEditRecordPopup) {
                            camSection.status = EnumSectionStatus.ACTIVE;
                        }
                        section.subSections.splice(1, 0, camSection);
                    }
                } else {
                    if (index >= 0) {
                        section.subSections.splice(index, 1);
                    }
                }
            }

            var num = 1;
            section.subSections.forEach(subSec => {
                subSec.number = num;
                num += 1;
            })

            let nextSection = 2;
            let nextCAMSection = 3;
            let firstQuestion = section.subSections.find(a => a.number == 1).questions.find(a => a.number == 1);
            if (firstQuestion && firstQuestion.answer.value && firstQuestion.data[0] == firstQuestion.answer.value[0]) {
                nextSection = 3;
                nextCAMSection = 4;
            }

            if (subSection.number == nextSection) {
                let _question = subSection.questions.find(a => a.number == 1);
                let value = _question.answer.value;
                let index = section.subSections.findIndex(a => a.number == nextCAMSection && a.therapieObj != null);
                let _CamTherapieFourthSubSection = this.LANGUAGE == LANGUAGE_ENUM.EN ? CamTherapieFourthSubSection_EN : CamTherapieFourthSubSection;


                _CamTherapieFourthSubSection.number = nextCAMSection;
                if (value && _question.data[0] === value[0]) {
                    if (index < 0) {
                        let camSection = cloneDeep(_CamTherapieFourthSubSection);
                        if (this.InEditRecordPopup) {
                            camSection.status = EnumSectionStatus.ACTIVE;
                        }
                        section.subSections.push(camSection);
                    }
                } else {
                    if (index >= 0) {
                        section.subSections.splice(index, 1);
                    }
                }
            }
            this.cd.detectChanges();
        }
    }

    fnSetNebSection(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        if (section.number == 8) {
            if (subSection.number == 1) {
                let addSecondSubsection: boolean = false;
                let answers = [];
                subSection.questions.forEach(question => {
                    if (question.answer.value) {
                        answers = [...answers, ...question.answer.value];
                    }
                    question.answer.extraOptions.forEach(option => {
                        if (option.value) {
                            answers.push(option.value);
                        }
                    })
                })

                answers.forEach(value => {
                    let _KeineNebenwirkungen = this.LANGUAGE == LANGUAGE_ENUM.EN ? KeineNebenwirkungen_EN : KeineNebenwirkungen;
                    if (_KeineNebenwirkungen !== value) {
                        addSecondSubsection = true;
                    }
                })

                let index = section.subSections.findIndex(a => a.number == 2);
                if (addSecondSubsection) {
                    if (index < 0) {
                        let nebSection = cloneDeep(this.LANGUAGE == LANGUAGE_ENUM.EN ? NebenwirkungenSecondSubSection_EN : NebenwirkungenSecondSubSection);
                        if (this.InEditRecordPopup) {
                            nebSection.status = EnumSectionStatus.ACTIVE;
                        }
                        section.subSections.push(nebSection);
                    }
                } else {
                    if (index >= 0) {
                        section.subSections.splice(index, 1);
                    }
                }
                this.cd.detectChanges();
            }
        }
    }

    fnValidateSymptomes(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        let showNext: boolean = true;
        //if (subSection.symptomeObj && subSection.symptomeObj.symptomes) {
        //    let symptomes = subSection.symptomeObj.symptomes;
        //    symptomes.forEach(symptome => {
        //        if (symptome.before.value > 0 || symptome.after.value > 0) {

        //        }
        //    })
        //}
        return showNext;
    }

    fnGetSymptomeValues(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        let Values: any[] = [];
        if (subSection.symptomeObj && subSection.symptomeObj.symptomes) {
            let symptomes = subSection.symptomeObj.symptomes;
            symptomes.forEach(symptome => {
                Values.push(`${symptome.before.value}`);
                Values.push(`${symptome.after.value}`);
                if (!!symptome.freeText) {
                    let freeText = this.fnExtractContent(symptome.freeText);
                    if (!!freeText) {
                        Values.push(freeText);
                    }
                }
            })
        }
        return Values;
    }

    isTherapieFreeTextShow(itemObj: ICAMTherapieObj | IMedikamentObj, response: IMedikamentResObj | INichtMedikamentResObj | ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        let value = response[itemKey].value;
        if (itemObj[itemKey].inputType == EnumQuestionType.DROPDOWN) {
            if (value) {
                if (itemObj[itemKey].multiple) {
                    var matched = freeTextInputs.filter(e => value.indexOf(e) !== -1);
                    return matched.length > 0;
                } else {
                    return freeTextInputs.indexOf(value) > -1;
                }
            }
        }
        else if (itemKey == 'product') {
            return freeTextInputs.indexOf(value) > -1;
        }
        return false;
    }

    fnValidateMedikament(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        let showNext: boolean = true;
        if (subSection.medikamentObj) {
            let columns: string[] = [];
            switch (subSection.medikamentObj.medikamentName) {
                case EnumMedikamentName.MedikamentTherapie:
                    columns = ["medikament", "darreichungsform", "vorTherapie", "unterTherapie"];
                    break;
                case EnumMedikamentName.NichtTherapie:
                    columns = ["medikament", "vorTherapie", "unterTherapie"];
                    break;
            }

            var isOneRequired = subSection.medikamentObj.required;
            subSection.medikamentObj.responseData.forEach((response: IMedikamentResObj | INichtMedikamentResObj) => {
                var validColumn = true;
                columns.forEach(column => {
                    if (!!!response[column].value) {
                        validColumn = false;
                    }
                    if (this.isTherapieFreeTextShow(subSection.medikamentObj, response, column)) {
                        if (!!!response[column].freeText) {
                            validColumn = false;
                        }
                    }
                })
                if (validColumn) {
                    isOneRequired = false;
                }
            })

            if (isOneRequired) {
                let response = subSection.medikamentObj.responseData[0];
                if (response) {
                    columns.forEach(column => {
                        var isRequired = subSection.medikamentObj[column].required;
                        if (!!!response[column].value && isRequired) {
                            response.hasError[column] = true;
                            showNext = false;
                        } else {
                            response.hasError[column] = false;
                        }
                        if (this.isTherapieFreeTextShow(subSection.medikamentObj, response, column)) {
                            if (!!!response[column].freeText && isRequired) {
                                response.hasError[column] = true;
                                showNext = false;
                            } else {
                                response.hasError[column] = false;
                            }
                        }
                    })
                } else {
                    showNext = false;
                }
            } else {
                showNext = true;
            }
        }
        return showNext;
    }

    fnGetMedikamentValues(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        let Values: any[] = [];
        if (subSection.medikamentObj) {
            let columns: string[] = [];
            switch (subSection.medikamentObj.medikamentName) {
                case EnumMedikamentName.MedikamentTherapie:
                    columns = ["medikament", "darreichungsform", "vorTherapie", "unterTherapie"];
                    break;
                case EnumMedikamentName.NichtTherapie:
                    columns = ["medikament", "vorTherapie", "unterTherapie"];
                    break;
            }

            subSection.medikamentObj.responseData.forEach((response: IMedikamentResObj | INichtMedikamentResObj) => {
                columns.forEach(column => {
                    if (!!response[column].value) {
                        Values.push(response[column].value);
                    }
                    if (this.isTherapieFreeTextShow(subSection.medikamentObj, response, column)) {
                        if (!!response[column].freeText) {
                            Values.push(response[column].freeText);
                        }
                    }
                })
                if (!!response.freeText) {
                    let freeText = this.fnExtractContent(response.freeText);
                    if (!!freeText) {
                        Values.push(freeText);
                    }
                }
            })
        }
        return Values;
    }

    fnGetMedikamentResponse(medikamentObj) {
        let columns: string[] = [];
        switch (medikamentObj.medikamentName) {
            case EnumMedikamentName.MedikamentTherapie:
                columns = ["medikament", "darreichungsform", "vorTherapie", "unterTherapie"];
                break;
            case EnumMedikamentName.NichtTherapie:
                columns = ["medikament", "vorTherapie", "unterTherapie"];
                break;
        }

        let responseData: any = [];
        medikamentObj.responseData.forEach((response: IMedikamentResObj | INichtMedikamentResObj) => {
            delete response.hasError;
            delete response.showFreeText;

            let returnData = false;
            columns.forEach(column => {
                if (!!response[column].value) {
                    returnData = true;
                }
                if (this.isTherapieFreeTextShow(medikamentObj, response, column)) {
                    if (!!response[column].freeText) {
                        returnData = true;
                    }
                }
            })
            if (!!response.freeText) {
                returnData = true;
            }
            if (returnData) {
                responseData.push(response);
            }
        })

        return responseData;
    }

    fnValidateCAMTherapie(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        let showNext: boolean = true;
        if (subSection.therapieObj) {
            let columns: string[] = [];
            switch (subSection.therapieObj.therapieName) {
                case EnumCAMTherapieName.CAMTherapie:
                    columns = ["category", "product", "startDate", "phaseDuration", "applicationUnit", "dailyDosage", "remarks"];
                    break;
                case EnumCAMTherapieName.CAMTherapieEnd:
                    columns = ["category", "product", "startDate", "endDate", "applicationUnit", "dailyDosage", "remarks"];
                    break;
            }

            var isOneRequired = subSection.therapieObj.required;
            subSection.therapieObj.responseData.forEach((response: ICAMTherapieResObj | ICAMTherapieEndResObj) => {
                var validColumn = true;
                columns.forEach(column => {
                    if (!!!response[column].value) {
                        validColumn = false;
                    }
                    if (this.isTherapieFreeTextShow(subSection.therapieObj, response, column)) {
                        if (!!!response[column].freeText) {
                            validColumn = false;
                        }
                    }
                })
                if (validColumn) {
                    isOneRequired = false;
                }
            })

            if (isOneRequired) {
                let response = subSection.therapieObj.responseData[0];
                if (response) {
                    columns.forEach(column => {
                        var isRequired = this.isCamTherapieRequired(subSection.therapieObj, response, column);
                        if (!!!response[column].value && isRequired) {
                            response.hasError[column] = true;
                            showNext = false;
                        } else {
                            response.hasError[column] = false;
                        }
                        if (this.isTherapieFreeTextShow(subSection.therapieObj, response, column)) {
                            if (!!!response[column].freeText && isRequired) {
                                response.hasError[column] = true;
                                showNext = false;
                            } else {
                                response.hasError[column] = false;
                            }
                        }
                    })
                } else {
                    showNext = false;

                }
            } else {
                showNext = true;
            }
        }
        return showNext;
    }

    isCamTherapieRequired(itemObj: ICAMTherapieObj, response: ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        if (itemKey == 'product') {
            let category = response['category'].value;
            switch (category) {
                case 'Cannabisextrakt':
                case 'Cannabisblüten':
                case 'Cannabiskapseln':
                case 'Kapseln':
                case 'Andere':
                case 'Cannabis extract':
                case 'Cannabis flowers':
                case 'Capsules':
                case 'Other':
                    return true;
                default:
                    return false;
            }
        } else {
            return itemObj[itemKey].required;
        }
    }

    fnGetCAMTherapieValues(section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        let Values: any[] = [];
        if (subSection.therapieObj) {
            let columns: string[] = [];
            switch (subSection.therapieObj.therapieName) {
                case EnumCAMTherapieName.CAMTherapie:
                    columns = ["category", "product", "startDate", "phaseDuration", "applicationUnit", "dailyDosage", "remarks"];
                    break;
                case EnumCAMTherapieName.CAMTherapieEnd:
                    columns = ["category", "product", "startDate", "endDate", "applicationUnit", "dailyDosage", "remarks"];
                    break;
            }

            subSection.therapieObj.responseData.forEach((response: ICAMTherapieResObj | ICAMTherapieEndResObj) => {
                columns.forEach(column => {
                    if (!!response[column].value) {
                        Values.push(response[column].value);
                    }
                    if (this.isTherapieFreeTextShow(subSection.therapieObj, response, column)) {
                        if (!!response[column].freeText) {
                            Values.push(response[column].freeText);
                        }
                    }
                })
            })
        }
        return Values;
    }

    fnGetCAMTherapieResponse(therapieObj) {
        let columns: string[] = [];
        switch (therapieObj.therapieName) {
            case EnumCAMTherapieName.CAMTherapie:
                columns = ["category", "product", "startDate", "phaseDuration", "applicationUnit", "dailyDosage", "remarks"];
                break;
            case EnumCAMTherapieName.CAMTherapieEnd:
                columns = ["category", "product", "startDate", "endDate", "applicationUnit", "dailyDosage", "remarks"];
                break;
        }


        let responseData: any = [];
        therapieObj.responseData.forEach((response: ICAMTherapieResObj | ICAMTherapieEndResObj) => {
            delete response.hasError;

            let returnData = false;
            columns.forEach(column => {
                if (!!response[column].value) {
                    returnData = true;
                }
                if (this.isTherapieFreeTextShow(therapieObj, response, column)) {
                    if (!!response[column].freeText) {
                        returnData = true;
                    }
                }
            })
            if (returnData) {
                responseData.push(response);
            }
        })
        return responseData;
    }

    fnExtractContent(html, space = true) {
        //return new DOMParser()
        //    .parseFromString(html, "text/html")
        //    .documentElement.textContent;

        var divTag = document.createElement('div');
        divTag.innerHTML = html;
        if (space) {
            var children = divTag.querySelectorAll('*');
            for (var i = 0; i < children.length; i++) {
                children[i].textContent += ' ';
            }
        }
        return [divTag.textContent || divTag.innerText].toString().replace(/ +/g, ' ').trim();
    }

    fnSetQuestionHasError(question: IQuestionnaireQuestion, showNext: boolean) {
        let value = question.answer.value;
        switch (question.inputType) {
            case EnumQuestionType.INPUT:
            case EnumQuestionType.MONTH:
            case EnumQuestionType.DATE:
                if (!!!value) {
                    question.hasError = true;
                } else {
                    question.hasError = false;
                }
                if (question.pattern) {
                    if (!question.pattern.test(value)) {
                        question.hasError = true;
                    }
                }
                break;
            case EnumQuestionType.TEXTAREA:
                value = this.fnExtractContent(value);
                if (!!!value) {
                    question.hasError = true;
                } else {
                    question.hasError = false;
                }
                if (question.pattern) {
                    if (!question.pattern.test(value)) {
                        question.hasError = true;
                    }
                }
                break;
            case EnumQuestionType.DROPDOWN:
                if (question.multiple) {
                    if (!!!value || !value.length) {
                        question.hasError = true;
                    } else {
                        question.hasError = false;
                    }
                } else {
                    if (!!!value) {
                        question.hasError = true;
                    } else {
                        question.hasError = false;
                    }
                }
                break;
            case EnumQuestionType.OPTION:
                if (!!!value || !value.length) {
                    question.hasError = true;
                } else {
                    question.hasError = false;
                }
                break;
            case EnumQuestionType.ICD10SEARCH:
                if (!question.answer.extraOptions.length) {
                    question.hasError = true;
                } else {
                    question.hasError = false;
                }
                break;
            case EnumQuestionType.POSNEGSLIDER:
                question.hasError = false;
                break;
        }
        if (question.validateValueWith) {
            let { sectionNumber, subSectionNumber, questionNumber } = question.validateValueWith;
            let wSection = this.QuestJSON.find(a => a.number == sectionNumber);
            if (wSection) {
                let wSubSection = wSection.subSections.find(a => a.number == subSectionNumber);
                if (wSubSection) {
                    let wQuestion = wSubSection.questions.find(a => a.number == questionNumber);
                    if (wQuestion) {
                        let wValue = wQuestion.answer.value;
                        if (wValue !== value) {
                            question.hasError = true;
                        }
                    }
                }
            }
        }

        if (this.isFreeTextShow(question)) {
            value = question.answer.freeText;
            if (!!!value) {
                question.hasError = true;
            } else {
                question.hasError = false;
            }
        }
        if (question.extraOption) {
            question.answer.extraOptions.forEach(option => {
                if (!!!option.value) {
                    option.hasError = true;
                    showNext = false;
                } else {
                    option.hasError = false;
                }
            })
        }

        if (question.hasError) {
            showNext = false;
        }
        return showNext;
    }


    fnSubmitForm(sIndex: number, ssIndex: number, section: IQuestionnaireSection, subSection: IQuestionnaireSubSection) {
        this.cd.detectChanges();
        this.fnValidateForm(sIndex, ssIndex, section, subSection, RecordStatusEnum.New);
    }

    fnValidateForm(sIndex: number, ssIndex: number, section: IQuestionnaireSection, subSection: IQuestionnaireSubSection, status: RecordStatusEnum) {
        let showNext: boolean = true;
        switch (subSection.sectionType) {
            case EnumSectionType.SYMPTOMES:
                showNext = this.fnValidateSymptomes(section, subSection);
                break;
            case EnumSectionType.MEDIKAMENT:
                showNext = this.fnValidateMedikament(section, subSection);
                break;
            case EnumSectionType.CAMTHERAPIE:
                showNext = this.fnValidateCAMTherapie(section, subSection);
                break;
            default:
                subSection.questions.forEach(question => {
                    if (question.required) {
                        showNext = this.fnSetQuestionHasError(question, showNext);
                    }
                })
                break;
        }
        if (showNext && subSection.required) {
            let showError = true;
            let extraOptionError: boolean = false;
            subSection.questions.forEach(question => {
                let value = question.answer.value;
                switch (question.inputType) {
                    case EnumQuestionType.INPUT:
                    case EnumQuestionType.MONTH:
                    case EnumQuestionType.DATE:
                        if (!!value) {
                            showError = false;
                        }
                        break;
                    case EnumQuestionType.TEXTAREA:
                        value = this.fnExtractContent(value);
                        if (!!value) {
                            showError = false;
                        }
                        break;
                    case EnumQuestionType.DROPDOWN:
                        if (question.multiple) {
                            if (value && value.length) {
                                showError = false;
                            }
                        } else {
                            if (value) {
                                showError = false;
                            }
                        }
                        break;
                    case EnumQuestionType.OPTION:
                        if (value && value.length) {
                            showError = false;
                        }
                        break;
                    case EnumQuestionType.ICD10SEARCH:
                        if (question.answer.extraOptions.length) {
                            showError = false;
                        }
                        break;
                    case EnumQuestionType.POSNEGSLIDER:
                        showError = false;
                        break;
                }

                if (this.isFreeTextShow(question)) {
                    value = question.answer.freeText;
                    if (!!value) {
                        showError = false;
                    }
                }
                if (question.extraOption) {
                    question.answer.extraOptions.forEach(option => {
                        if (!!option.value) {
                            showError = false;
                            option.hasError = false;
                        } else {
                            option.hasError = true;
                            extraOptionError = true;
                        }
                    })
                }
            })

            if (showError) {
                subSection.questions.forEach(question => {
                    showNext = this.fnSetQuestionHasError(question, showNext);
                });
            } else {
                showNext = !extraOptionError;
            }
        }

        if (showNext) {
            //this.fnSetCamSection(section, subSection);
            //this.fnSetNebSection(section, subSection);
        }
        if (showNext) {
            subSection.hasError = false;
            //if (subSection.symptomeObj) {
            //    this.fnUpdateSymptomes(section, subSection);
            //}
            this.fnGoToNextSection(sIndex, ssIndex, status);
        } else {
            subSection.hasError = true;
            if (this.InEditRecordPopup) {
                this.navigateToSection(sIndex, ssIndex);
            }
        }
        this.cd.detectChanges();
        return showNext;
    }

    fnGoToPreviousSection(sIndex: number, ssIndex: number) {
        let prevSIndex = sIndex;
        let prevSSIndex = ssIndex;
        let sLength = this.QuestJSON.length;

        for (var i = 0; i < sLength; i++) {
            let subSections = this.QuestJSON[i].subSections;
            for (var j = 0; j < subSections.length; j++) {
                if (i > sIndex || (i >= sIndex && j >= ssIndex)) {
                    this.QuestJSON[i].status = null;
                    this.QuestJSON[i].subSections[j].status = null;
                } else {
                    prevSIndex = i;
                    prevSSIndex = j;
                }
            }
        }
        if (prevSIndex >= 0) {
            if (!this.InEditRecordPopup) {
                this.QuestJSON[prevSIndex].status = EnumSectionStatus.ACTIVE;
                this.QuestJSON[prevSIndex].subSections[prevSSIndex].status = EnumSectionStatus.ACTIVE;
            }

            if (prevSIndex != sIndex || prevSSIndex != ssIndex) {
                this.navigateToSection(prevSIndex, prevSSIndex);
            }
        }
    }

    fnGoToNextSection(sIndex: number, ssIndex: number, status: RecordStatusEnum) {
        let nextSIndex = sIndex;
        let nextSSIndex = ssIndex;
        let sLength = this.QuestJSON.length;
        for (var i = 0; i < sLength; i++) {
            let subSections = this.QuestJSON[i].subSections;
            var ssLength = subSections.length;
            if (ssIndex == ssLength - 1) {
                if (sIndex == i) {
                    if (!this.InEditRecordPopup) {
                        this.QuestJSON[sIndex].status = EnumSectionStatus.COMPLETED;
                        this.QuestJSON[sIndex].subSections[ssIndex].status = EnumSectionStatus.COMPLETED;
                    }
                    nextSIndex = i + 1;
                    nextSSIndex = 0;
                }
            }
            else {
                for (var j = 0; j < subSections.length; j++) {
                    if (sIndex == i && ssIndex == j) {
                        if (!this.InEditRecordPopup) {
                            this.QuestJSON[sIndex].subSections[ssIndex].status = EnumSectionStatus.COMPLETED;
                        }
                        nextSSIndex = j + 1;
                    }
                }
            }
        }
        if (nextSIndex < sLength) {
            if (!this.InEditRecordPopup) {
                this.QuestJSON[nextSIndex].status = EnumSectionStatus.ACTIVE;
                this.QuestJSON[nextSIndex].subSections[nextSSIndex].status = EnumSectionStatus.ACTIVE;
            }

            if (!this.InEditRecordPopup) {
                if (nextSIndex != sIndex || nextSSIndex != ssIndex) {
                    this.navigateToSection(nextSIndex, nextSSIndex);
                }
            }
        } else {
            this.fnGenerateResponse(status);
        }
    }

    navigateToSection(sIndex, ssIndex) {
        this.cd.detectChanges();
        setTimeout(() => {
            const elmId = `frageboge_section_${sIndex}_subsection_${ssIndex}`;
            const elm: HTMLElement = document.getElementById(elmId) as HTMLElement;
            if (elm) {
                var marginTop = 70;
                const fragContainer = document.getElementById("frageboge_container") as HTMLElement;
                if (fragContainer) {
                    fragContainer.scrollTo(
                        {
                            top: elm.offsetTop - marginTop,
                            behavior: "smooth"
                        }
                    )
                }
            }
        })
    }

    fnGenerateResponse(status: RecordStatusEnum) {
        let responseJSON: IQuestionnaireResponse[] = [];
        let Geschlecht = "";
        let Beschwerdebild = "";
        let Indikation = "";
        let IndikationAndre = false;
        let Symptoms: { Value: string, Andre: boolean }[] = [];
        let CAMTherapie: string[] = [];
        let CAMTherapieEnd: string[] = [];
        let SearchData: string[] = [];
        let Code = "";
        let Email = "";
        let Fachrichtung = "";
        let Bundesland = "";

        this.QuestJSON.forEach((section, sIndex) => {
            section.subSections.forEach((subSection, ssIndex) => {
                var responseObj: IQuestionnaireResponse = {
                    sectionNumber: section.number,
                    sectionText: section.title,
                    subSectionNumber: subSection.number,
                    subSectionText: subSection.title,
                    subSectionType: subSection.sectionType
                }
                switch (subSection.sectionType) {
                    case EnumSectionType.SYMPTOMES:
                        let symptomes = cloneDeep(subSection.symptomeObj.symptomes);
                        symptomes.forEach(symptome => {
                            delete symptome.showFreeText;
                        })
                        responseJSON.push({
                            ...responseObj,
                            inputType: "Symptomes",
                            response: symptomes
                        })

                        SearchData = [...SearchData, ...this.fnGetSymptomeValues(section, subSection)];
                        break;
                    case EnumSectionType.MEDIKAMENT:
                        let medikamentObj = cloneDeep(subSection.medikamentObj);
                        let mResponseData = this.fnGetMedikamentResponse(medikamentObj);
                        if (mResponseData.length > 0) {
                            responseJSON.push({
                                ...responseObj,
                                inputType: medikamentObj.medikamentName,
                                response: mResponseData
                            })
                            SearchData = [...SearchData, ...this.fnGetMedikamentValues(section, subSection)];
                        }
                        break;
                    case EnumSectionType.CAMTHERAPIE:
                        let therapieObj = cloneDeep(subSection.therapieObj);
                        therapieObj.responseData.forEach(response => {
                            if (therapieObj.therapieName == EnumCAMTherapieName.CAMTherapie) {
                                CAMTherapie.push(getCategoryLabel(response.category.value, this.LANGUAGE));
                            } else if (therapieObj.therapieName == EnumCAMTherapieName.CAMTherapieEnd) {
                                CAMTherapieEnd.push(getCategoryLabel(response.category.value, this.LANGUAGE));
                            }
                        })

                        let tResponseData = this.fnGetCAMTherapieResponse(therapieObj);
                        if (tResponseData.length > 0) {
                            responseJSON.push({
                                ...responseObj,
                                inputType: therapieObj.therapieName,
                                response: tResponseData
                            })
                            SearchData = [...SearchData, ...this.fnGetCAMTherapieValues(section, subSection)];
                        }
                        break;
                    default:
                        subSection.questions.forEach((question, qIndex) => {
                            if (section.number == 2 && subSection.number == 1 && question.number == 6) {
                                Geschlecht = question.answer.value[0];
                            }
                            if (section.number == 3 && subSection.number == 1) {
                                if (question.number == 1) {
                                    Beschwerdebild = question.answer.value;
                                }
                                if (question.number == 2) {
                                    Indikation = question.answer.freeText || question.answer.value;
                                    if (question.answer.freeText) {
                                        IndikationAndre = true;
                                    }
                                }
                            }
                            if (section.number == 4 && subSection.number == 1) {
                                let values = question.answer.value;
                                if (values) {
                                    values.forEach(val => {
                                        Symptoms.push({ Value: val, Andre: false });
                                    })

                                }
                                question.answer.extraOptions.forEach(option => {
                                    if (option.value) {
                                        Symptoms.push({ Value: option.value, Andre: true });
                                    }
                                })
                            }

                            if (section.number == 10 && subSection.number == 1) {
                                if (question.number == 1) {
                                    Email = question.answer.value;
                                }
                                if (question.number == 3) {
                                    Code = question.answer.value || "";
                                }
                            }

                            if (section.number == 1 && subSection.number == 1) {
                                if (question.number == 1) {
                                    Fachrichtung = question.answer.value;
                                }
                                if (question.number == 2) {
                                    Bundesland = question.answer.value;
                                }
                            }

                            let value = question.answer.value;
                            switch (question.inputType) {
                                case EnumQuestionType.INPUT:
                                case EnumQuestionType.MONTH:
                                case EnumQuestionType.DATE:
                                    if (!!value) {
                                        SearchData.push(`${value}`);
                                    }
                                    break;
                                case EnumQuestionType.TEXTAREA:
                                    value = this.fnExtractContent(value);
                                    if (!!value) {
                                        SearchData.push(`${value}`);
                                    }
                                    break;
                                case EnumQuestionType.DROPDOWN:
                                    if (question.multiple) {
                                        if (value && value.length) {
                                            SearchData = [...SearchData, ...value];
                                        }
                                    } else {
                                        if (!!value) {
                                            SearchData.push(`${value}`);
                                        }
                                    }
                                    break;
                                case EnumQuestionType.OPTION:
                                    if (value && value.length) {
                                        SearchData = [...SearchData, ...value];
                                    }
                                    break;
                                case EnumQuestionType.ICD10SEARCH:
                                    if (question.answer.extraOptions.length) {
                                        const stringOptions = question.answer.extraOptions
                                            .map(opt => {
                                                if (typeof opt === 'string') return opt;
                                                if (typeof opt === 'object' && opt !== null) {
                                                    return opt.value;
                                                }
                                                return null;
                                            })
                                            .filter(opt => typeof opt === 'string');
                                        SearchData = [...SearchData, ...stringOptions];
                                    }
                                    break;
                                case EnumQuestionType.POSNEGSLIDER:
                                    SearchData.push(`${value}`);
                                    break;
                            }

                            if (this.isFreeTextShow(question)) {
                                value = question.answer.freeText;
                                if (!!value) {
                                    SearchData.push(value);
                                }
                            }
                            if (question.extraOption) {
                                question.answer.extraOptions.forEach(option => {
                                    if (!!option.value) {
                                        SearchData.push(option.value);
                                    }
                                })
                            }

                            responseJSON.push({
                                ...responseObj,
                                questionNumber: question.number,
                                questionText: question.title,
                                inputType: question.inputType,
                                response: question.answer
                            })
                        })
                        break;
                }
            })
        })



        let payload: any = {
            Status: status,
            Geschlecht: Geschlecht,
            Beschwerdebild: Beschwerdebild,
            Indikation: Indikation,
            IndikationAndre: IndikationAndre,
            Symptoms: Symptoms,
            CAMTherapie: CAMTherapie,
            CAMTherapieEnd: CAMTherapieEnd,
            JsonData: responseJSON,
            SearchData: SearchData,
            Code: Code,
            Email: Email,
            Fachrichtung: Fachrichtung,
            Bundesland: Bundesland
        }
        this.fnSaveDateneingabeData(payload);
    }

    fnSaveDateneingabeData(payload) {

    }

    fnShowInfoPopup() {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const componentRef = this.vcr.createComponent(PEPInfoComponent);

        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            id: "jsPanelInfo",
            theme: 'dark',
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: "PEP Info",
            //header: false,
            //border: '1px solid #B4B4B4',
            //borderRadius: '10px',
            //addCloseControl: 1,
            //css: {
            //    content: 'pep-info-popup-container',
            //    panel: 'pep-info-panel'
            //},
            onwindowresize: true,
            dragit: {
                disable: false
            },
            resizeit: {
                disable: false
            },
            onstatuschange: (panel, status) => {
            },
            content: element,
            callback: function (panel) {
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup);
    }

}
